import { useEffect } from 'react'
import { useEMTDispatch, useEMTState } from '@/store'
import useCurrentUser from '@/hooks/useCurrentUser'
import * as PetsitterUserServiceHelper from '../PetsitterUserServiceHelper'

export const usePetsitterUser = () => {
  const dispatch = useEMTDispatch()
  const { petsitterUser } = useEMTState()
  const { currentPetsitter } = useCurrentUser()

  const fetchPetsitterData = async () => {
    try {
      return await PetsitterUserServiceHelper.dispatchGetPetsitterInfoAsync(dispatch)()
    } catch (error) {
      console.error('Failed to fetch petsitter data:', error)
      return undefined
    }
  }

  useEffect(() => {
    if (!petsitterUser.currentPetsitter && !petsitterUser.isLoading && currentPetsitter) {
      fetchPetsitterData()
    }
  }, [currentPetsitter])

  return {
    petsitter: petsitterUser.currentPetsitter,
    // @ts-expect-error
    id: petsitterUser.currentPetsitter?.uuid,
    // @ts-expect-error
    avatar: petsitterUser.currentPetsitter?.mainPicture?.thumbnailUrl,
    // @ts-expect-error
    displayName: petsitterUser.currentPetsitter?.name,
    isLoading: petsitterUser.isLoading,
    // @ts-expect-error
    isValidated: petsitterUser.currentPetsitter?.isValidated,
    isPayoutEligible: petsitterUser.currentPetsitter?.isPayoutEligible,
    error: petsitterUser.error,
    refetch: fetchPetsitterData,
  }
}
